// extracted by mini-css-extract-plugin
export default {"tag":"MetaTag_tag__ZcvcZ"};